import { AutoComplete, Form, Input, Modal, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { TransformedDataType } from "../../../api/numbers/getSipNumbersData";
import { getSipTypes } from "../../../api/numbers/getSipTypes";
import { postSipUserAssignments } from "../../../api/numbers/postSipUserAssignments";
import { postMeetingRoomAssignments } from "../../../api/numbers/postSipMeetingRoomAssignments";
import { getMeetingRooms } from "../../../api/numbers/getMeetingRooms";
import {
  getValueFromLabel,
  getLabelsAsValues,
  SelectOptionsType,
  selectOptionsComparator,
  createRegex,
} from "../../../utils/select-helpers";
import { getUsersUnassigned } from "../../../api/numbers/getUsersUnassigned";
import { postSipOtherAssignments } from "../../../api/numbers/postSipOtherAssignments";
import { getPoolsId } from "../../../api/pool/getPoolsId";
import DisplayFieldValues from "../../../components/DisplayFieldValues";
import HeaderContext from "../../../components/layout/header/header-context/HeaderContext";

interface Props {
  isVisible: boolean;
  handleClose: (refreshData?: boolean) => void;
  sipNumberRecord?: TransformedDataType;
}

interface State {
  isModalVisible: boolean;
  sipTypeOptions?: SelectOptionsType[];
  locationOptions?: SelectOptionsType[];
  meetingRoomOptions?: SelectOptionsType[];
  usersUnassignedOptions?: SelectOptionsType[];
  voicemailUnassignedOptions?: SelectOptionsType[];
  poolName?: string;
  isLoading_getSipTypes: boolean;
  isLoading_submit: boolean;
  selectedType: "MEETING_ROOM" | "USER" | "OTHER" | "VOICE_MAIL" | "NONE";
  submitError?: string;
  usernameUserRegex: RegExp;
  usernameVoicemailRegex: RegExp;
  meetingRoomRegex: RegExp;
}

const AddNumberAssignmentFormModal: React.FC<Props> = ({
  isVisible,
  handleClose,
  sipNumberRecord,
}) => {
  const [form] = Form.useForm();
  const { currentUserId } = useContext(HeaderContext);

  const [state, setState] = useState<State>({
    isModalVisible: false,
    sipTypeOptions: [],
    locationOptions: [],
    meetingRoomOptions: [],
    usersUnassignedOptions: [],
    voicemailUnassignedOptions: [],
    poolName: "",
    isLoading_getSipTypes: false,
    isLoading_submit: false,
    selectedType: "NONE",
    submitError: "",
    usernameUserRegex: / /,
    usernameVoicemailRegex: / /,
    meetingRoomRegex: / /,
  });

  const {
    isModalVisible,
    sipTypeOptions,
    locationOptions,
    meetingRoomOptions,
    usersUnassignedOptions,
    voicemailUnassignedOptions,
    selectedType,
    submitError,
    isLoading_getSipTypes,
    isLoading_submit,
    usernameUserRegex,
    usernameVoicemailRegex,
    meetingRoomRegex,
  } = state;

  const handleCancel = () => {
    form.resetFields();
    setState((prevState) => ({
      ...prevState,
      selectedType: "NONE",
      submitError: "",
    }));
    handleClose();
  };

  const handleSubmit = () => {
    setState((prevState) => ({
      ...prevState,
      submitError: "",
    }));
    form
      .validateFields()
      .then((formFields) => {
        console.log("onOk sipNumberRecord: %o", sipNumberRecord);
        console.log("onOk formFields: %o", formFields);

        if (selectedType === "MEETING_ROOM") {
          const payload = {
            clientId: currentUserId,
            sipNumberId: sipNumberRecord?.id || -1,
            meetingRoomId: Number(
              getValueFromLabel(formFields.meetingRoom, meetingRoomOptions)
            ),
          };
          console.log("Submitting postMeetingRoomAssignments: %o", payload);

          setState((prevState) => ({ ...prevState, isLoading_submit: true }));
          postMeetingRoomAssignments(payload)
            .then((response) => {
              console.log("submitResponse:%o", response);
              if (response?.error) {
                setState((prevState) => ({
                  ...prevState,
                  submitError: response.error,
                }));
              } else {
                form.resetFields();
                setState((prevState) => ({
                  ...prevState,
                  submitError: "",
                  selectedType: "NONE",
                }));
                handleClose(true);
              }
            })
            .finally(() => {
              setState((prevState) => ({
                ...prevState,
                isLoading_submit: false,
              }));
            });
        } else if (selectedType === "USER") {
          const payload = {
            clientId: currentUserId,
            sipNumberId: sipNumberRecord?.id || -1,
            username: formFields.usernameUser,
          };
          console.log("Submitting postSipUserAssignments payload: %o", payload);
          setState((prevState) => ({ ...prevState, isLoading_submit: true }));
          postSipUserAssignments(payload)
            .then((response) => {
              console.log("submitResponse:%o", response);
              if (response?.error) {
                setState((prevState) => ({
                  ...prevState,
                  submitError: response.error,
                }));
              } else {
                form.resetFields();
                setState((prevState) => ({
                  ...prevState,
                  submitError: "",
                  selectedType: "NONE",
                }));
                handleClose(true);
              }
            })
            .finally(() => {
              setState((prevState) => ({
                ...prevState,
                isLoading_submit: false,
              }));
            });
        } else if (selectedType === "OTHER") {
          const payload = {
            clientId: currentUserId,
            locationId: getValueFromLabel(formFields.location, locationOptions),
            sipNumberId: sipNumberRecord?.id || -1,
            sipType: formFields.sipType,
            username: formFields.usernameOther,
          };
          console.log(
            "Submitting postSipOtherAssignments payload: %o",
            payload
          );
          setState((prevState) => ({ ...prevState, isLoading_submit: true }));
          postSipOtherAssignments(payload)
            .then((response) => {
              console.log("submitResponse:%o", response);
              if (response?.error) {
                setState((prevState) => ({
                  ...prevState,
                  submitError: response.error,
                }));
              } else {
                form.resetFields();
                setState((prevState) => ({
                  ...prevState,
                  submitError: "",
                  selectedType: "NONE",
                }));
                handleClose(true);
              }
            })
            .finally(() => {
              setState((prevState) => ({
                ...prevState,
                isLoading_submit: false,
              }));
            });
        } else if (selectedType === "VOICE_MAIL") {
          const payload = {
            clientId: currentUserId,
            sipNumberId: sipNumberRecord?.id || -1,
            username: formFields.usernameVoicemail,
          };
          console.log("Submitting postSipUserAssignments payload: %o", payload);
          setState((prevState) => ({ ...prevState, isLoading_submit: true }));
          postSipUserAssignments(payload)
            .then((response) => {
              console.log("submitResponse:%o", response);
              if (response?.error) {
                setState((prevState) => ({
                  ...prevState,
                  submitError: response.error,
                }));
              } else {
                form.resetFields();
                setState((prevState) => ({
                  ...prevState,
                  submitError: "",
                  selectedType: "NONE",
                }));
                handleClose(true);
              }
            })
            .finally(() => {
              setState((prevState) => ({
                ...prevState,
                isLoading_submit: false,
              }));
            });
        }
      })
      .catch((err) => {
        console.log("form.validateFields ERROR: %o", err);
      });
  };

  useEffect(() => {
    if (isVisible !== isModalVisible) {
      setState((prevState) => ({
        ...prevState,
        isModalVisible: isVisible,
      }));

      if (!isVisible) return;

      // +++ set default state for type dropdown +++
      setState((prevState) => ({
        ...prevState,
        selectedType: "USER",
      }));
      form.setFieldsValue({
        sipType: "User",
      });
      // --- set default state for type dropdown ---

      console.log("sipNumberRecord: %o", sipNumberRecord);
      getUsersUnassigned().then((response) => {
        if (response.data) {
          console.log("usersUnassigned: %o", response.data);
          const usersUnassigned: string[] = [];
          const voicemailUnassigned: string[] = [];

          response.data.forEach((user) => {
            if (user.isVoicemail) {
              voicemailUnassigned.push(`${user.username}`);
            } else {
              usersUnassigned.push(`${user.username}`);
            }
          });

          const usersUnassignedOptions: SelectOptionsType[] = usersUnassigned
            .sort()
            .map((user) => {
              return {
                title: "",
                value: user,
                label: user,
              };
            });

          const voicemailUnassignedOptions: SelectOptionsType[] =
            voicemailUnassigned.sort().map((user) => {
              return {
                title: "",
                value: user,
                label: user,
              };
            });

          setState((prevState) => ({
            ...prevState,
            usersUnassignedOptions: usersUnassignedOptions,
            voicemailUnassignedOptions: voicemailUnassignedOptions,
          }));
        }
      });

      setState((prevState) => ({
        ...prevState,
        isLoading_getSipTypes: true,
      }));
      getSipTypes()
        .then((response) => {
          if (response.data) {
            console.log("sipTypes: %o", response.data);
            setState((prevState) => ({
              ...prevState,
              sipTypeOptions: response.data,
            }));
          }
        })
        .finally(() => {
          setState((prevState) => ({
            ...prevState,
            isLoading_getSipTypes: false,
          }));
        });

      sipNumberRecord?.pool?.id &&
        getPoolsId({ poolId: `${sipNumberRecord?.pool?.id}` }).then(
          (response) => {
            console.log(
              `getPoolsId({poolId: ${sipNumberRecord?.pool?.id} }): %o`,
              response.data
            );
            if (response.data) {
              const locationOptions = (response.data.locationNames || [])
                .map((location) => ({
                  title: "",
                  value: `${location}`,
                  label: `${location}`,
                }))
                .sort(selectOptionsComparator);
              console.log("locationOptions: %o", locationOptions);
              setState((prevState) => ({
                ...prevState,
                locationOptions: locationOptions,
                poolName: response.data!.name,
              }));
            }
          }
        );

      getMeetingRooms().then((response) => {
        console.log("meetingRooms: %o", response.data);
        if (response.data) {
          setState((prevState) => ({
            ...prevState,
            meetingRoomOptions: response.data,
          }));
        }
      });
    }
    // eslint-disable-next-line
  }, [isVisible, isModalVisible]);

  return (
    <Modal
      title={`Add New Assignment`}
      maskClosable={false}
      open={isModalVisible}
      onCancel={handleCancel}
      cancelText="Cancel"
      okText="Submit"
      onOk={handleSubmit}
      okButtonProps={{
        className: "bdo-red-button-modal",
        disabled: isLoading_submit,
      }}
      cancelButtonProps={{
        className: "bdo-grey-button-modal",
      }}
    >
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
        <DisplayFieldValues
          labelValues={[
            {
              label: "Number",
              value: sipNumberRecord?.phoneNumberX,
            },
          ]}
        />
        <Form.Item
          name="sipType"
          label="Type:"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[{ required: true, message: "Select a type" }]}
        >
          <Select
            loading={isLoading_getSipTypes}
            placeholder="Select a type"
            onChange={(selectedLabel) => {
              console.log("SelectedType: %o", selectedLabel);
              setState((prevState) => ({
                ...prevState,
                selectedType:
                  selectedLabel === "Voicemail"
                    ? "VOICE_MAIL"
                    : selectedLabel === "Meeting Room"
                      ? "MEETING_ROOM"
                      : selectedLabel === "User"
                        ? "USER"
                        : selectedLabel === ""
                          ? "NONE"
                          : "OTHER",
              }));
            }}
            allowClear
            options={getLabelsAsValues(sipTypeOptions)}
          ></Select>
        </Form.Item>

        {selectedType === "MEETING_ROOM" && (
          <Form.Item
            name="meetingRoom"
            label="Meeting Room:"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[{ required: true, message: "Select a meeting room" }]}
          >
            <AutoComplete
              placeholder="Select a Meeting Room"
              onChange={(value: string) => {
                setState((prevState) => ({
                  ...prevState,
                  meetingRoomRegex: createRegex(value),
                }));
              }}
              allowClear
              options={getLabelsAsValues(meetingRoomOptions)}
              filterOption={(inputValue, option) => {
                return meetingRoomRegex.test(option!.value);
              }}
            ></AutoComplete>
          </Form.Item>
        )}

        {selectedType === "USER" && (
          <>
            <Form.Item
              label="Username:"
              name="usernameUser"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: "Enter the username" }]}
            >
              <AutoComplete
                placeholder="Select a user"
                onChange={(value: string) => {
                  setState((prevState) => ({
                    ...prevState,
                    usernameUserRegex: createRegex(value),
                  }));
                }}
                allowClear
                options={usersUnassignedOptions}
                filterOption={(inputValue, option) => {
                  return usernameUserRegex.test(option!.value);
                }}
              ></AutoComplete>
            </Form.Item>
          </>
        )}

        {selectedType === "VOICE_MAIL" && (
          <>
            <Form.Item
              label="Username:"
              name="usernameVoicemail"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: "Enter the username" }]}
            >
              <AutoComplete
                placeholder="Select a user"
                onChange={(value: string) => {
                  setState((prevState) => ({
                    ...prevState,
                    usernameVoicemailRegex: createRegex(value),
                  }));
                }}
                allowClear
                options={voicemailUnassignedOptions}
                filterOption={(inputValue, option) => {
                  return usernameVoicemailRegex.test(option!.value);
                }}
              ></AutoComplete>
            </Form.Item>
          </>
        )}

        {selectedType === "OTHER" && (
          <>
            <Form.Item
              label="Username"
              name="usernameOther"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                { required: true, message: "Enter the username" },
                { max: 20, message: "Username cannot exceed 20 characters" },
              ]}
            >
              <Input />
            </Form.Item>
          </>
        )}
      </Form>
      {submitError && <div className="text-red-500">{submitError}</div>}
    </Modal>
  );
};

export default AddNumberAssignmentFormModal;
